import { Box, Button, Card, Heading, Stack, Text, VStack } from "@chakra-ui/react";
import { brandColors } from "@/theme/colors";

/**
 * Example component demonstrating how to use your brand colors
 * with Chakra UI using the semantic naming convention.
 */
export function BrandColorExamples() {
  return (
    <VStack gap={8} p={6} align="stretch">
      <Heading size="lg">Brand Color Examples</Heading>

      {/* Primary color variants */}
      <Card.Root>
        <Card.Body>
          <Heading size="md" mb={4}>
            Primary Color Variants
          </Heading>
          <Stack direction="row" gap={4}>
            <Box bg="primary-subtle" color="on-primary-subtle" p={4} borderRadius="md" minW="120px" textAlign="center">
              <Text fontWeight="semibold">Subtle</Text>
              <Text fontSize="sm">primary-subtle</Text>
            </Box>

            <Box bg="primary-base" color="on-primary-base" p={4} borderRadius="md" minW="120px" textAlign="center">
              <Text fontWeight="semibold">Base</Text>
              <Text fontSize="sm">primary-base</Text>
            </Box>

            <Box bg="primary-bold" color="on-primary-bold" p={4} borderRadius="md" minW="120px" textAlign="center">
              <Text fontWeight="semibold">Bold</Text>
              <Text fontSize="sm">primary-bold</Text>
            </Box>
          </Stack>
        </Card.Body>
      </Card.Root>

      {/* Button variants */}
      <Card.Root>
        <Card.Body>
          <Heading size="md" mb={4}>
            Button Variants
          </Heading>
          <Stack direction="row" gap={4}>
            <Button colorPalette="primary" variant="outline">
              Outline Button
            </Button>
            <Button colorPalette="primary" variant="solid">
              Solid Button
            </Button>
            <Button colorPalette="primary" variant="ghost">
              Ghost Button
            </Button>
          </Stack>
        </Card.Body>
      </Card.Root>

      {/* Interactive states */}
      <Card.Root>
        <Card.Body>
          <Heading size="md" mb={4}>
            Interactive States
          </Heading>
          <Stack direction="row" gap={4}>
            <Button
              colorPalette="primary"
              variant="solid"
              _hover={{ bg: "primary-hover" }}
              _active={{ bg: "primary-active" }}
            >
              Hover & Active States
            </Button>
          </Stack>
        </Card.Body>
      </Card.Root>

      {/* Usage with helper functions */}
      <Card.Root>
        <Card.Body>
          <Heading size="md" mb={4}>
            Using Color Helpers
          </Heading>
          <Box bg={brandColors.primary.subtle} color={brandColors.onPrimary.subtle} p={4} borderRadius="md">
            <Text>This uses the brandColors helper for type-safe color references.</Text>
          </Box>
        </Card.Body>
      </Card.Root>

      {/* Color scale demonstration */}
      <Card.Root>
        <Card.Body>
          <Heading size="md" mb={4}>
            Full Color Scale
          </Heading>
          <Stack direction="row" gap={2}>
            <Box bg="primary.50" p={2} borderRadius="sm" minW="60px" textAlign="center">
              <Text fontSize="xs">50</Text>
            </Box>
            <Box bg="primary.100" p={2} borderRadius="sm" minW="60px" textAlign="center">
              <Text fontSize="xs">100</Text>
            </Box>
            <Box bg="primary.200" p={2} borderRadius="sm" minW="60px" textAlign="center">
              <Text fontSize="xs">200</Text>
            </Box>
            <Box bg="primary.300" p={2} borderRadius="sm" minW="60px" textAlign="center">
              <Text fontSize="xs">300</Text>
            </Box>
            <Box bg="primary.400" p={2} borderRadius="sm" minW="60px" textAlign="center">
              <Text fontSize="xs">400</Text>
            </Box>
            <Box bg="primary.500" p={2} borderRadius="sm" minW="60px" textAlign="center">
              <Text fontSize="xs">500</Text>
            </Box>
            <Box bg="primary.600" p={2} borderRadius="sm" minW="60px" textAlign="center">
              <Text fontSize="xs">600</Text>
            </Box>
            <Box bg="primary.700" p={2} borderRadius="sm" minW="60px" textAlign="center">
              <Text fontSize="xs">700</Text>
            </Box>
            <Box bg="primary.800" p={2} borderRadius="sm" minW="60px" textAlign="center">
              <Text fontSize="xs">800</Text>
            </Box>
            <Box bg="primary.900" p={2} borderRadius="sm" minW="60px" textAlign="center">
              <Text fontSize="xs">900</Text>
            </Box>
          </Stack>
        </Card.Body>
      </Card.Root>
    </VStack>
  );
}
